import React, {useState, useRef} from 'react';
import '../../../css/claimbottomsheet.scss';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import { useEffect } from "react";
import APICall from '../../actions/apicall';
import Cookies from "js-cookie";
import shareGrey from "../../../images/shareGrey.png";
import cancelIcon from '../../../images/cancelIcon.png';
import Share from '../popups/ShareEmail';
import Submit from '../reusable/Submit';
import Mappings from '../../actions/mappings';
import BusinessInterestSheet from './BusinessInterests';
import { trimCharacters } from '../../Helper';
import SVGImage from '../reusable/SelectIcon';
import { selectCategoryName } from '../../actions/findcategory';

function ClaimBottomSheet(props) {
    const accessToken = Cookies.get('access_token') ?? null;
    const [userLiked, setUserLiked] = useState(false);
    const [openShare, setOpenShare] = useState(false);
    const [emailAddress, setEmailAddress] = useState('');
    const [valuationValue, setValuationValue] = useState('');
    const [showValuationData, setShowValuationData] = useState(false);
    const [goText, setGoText] = useState('Go');
    const [showSignUpError, setShowSignUpError] = useState(false);
    const [signUpError, setSignUpError] = useState('');
    const [showCopiedMessage, setShowCopiedMessage] = useState(false);
    const [showLoginLink, setShowLoginLink] = useState(false);
    const [openInterestDropdown, setOpenInterestDropdown] = useState(false);
    const [showThanksMessage, setShowThanksMessage] = useState(false);
    const [active, setActive] = useState([]);
    // const [showLoader, setShowLoader] = useState(false);
    const [businessData, setBusinessData] = useState({});
    const [openBusinessInterests, setOpenBusinessInterests] = useState(false);

    const createPassword = 'create';
    const closeSheet = 'close';
    const addBusiness = 'add';
    const toolTipElement = useRef();
    const interestElement = useRef();
    let userId = Cookies.get('rs11_user_id') ?? 0;
    const businessId = props.business ? props.business.id : null;
    let suggestedValue = window.localStorage.getItem('searchValue');

    const handleCloseButtonClick = (action) => {
        if(action == closeSheet){
            window.dataLayer.push({'event': 'business_sheet_close', 'businessId': businessId})
            setBusinessData({});
        }
        if(action == addBusiness){
            window.dataLayer.push({
                'event': 'add_business_start',
                'addBusinessTriggeredFrom': 'use_case_3'
            });
        }

        if (action != 'contact' && action != 'own') {
            setUserLiked(false);
            setOpenShare(false);
            setEmailAddress('');
            setValuationValue('');
            setShowValuationData(false);
            setGoText('Go');
            setShowSignUpError(false);
            setSignUpError('');
            setShowCopiedMessage(false);
            setShowLoginLink(false);
            setOpenInterestDropdown(false);
            setActive([]);
            setShowThanksMessage(false);
        }
        props.onBottomSheetClose(action, emailAddress);
    };

    const handleShowLogin = () => {
        window.dataLayer.push({'event': 'business_sheet_sign_in'});
        props.onBottomSheetClose('signin', emailAddress);
    }

    const handleShowInterestDropdown = () => {
        window.dataLayer.push({'event': 'business_interests_open'});
        Object.keys(businessData).length > 0 && setOpenBusinessInterests(true);
    }

    const handleLikeBusiness = () => {
        if (accessToken != null) {
            if (Object.keys(businessData).length > 0) {
                let data = {
                    business_id: businessId,
                    liked: (!userLiked)
                }
                if (!userLiked) {
                    setUserLiked(true);
                    window.dataLayer.push({'event': 'like', 'businessId': businessId});
                }
                else {
                    setUserLiked(false);
                    window.dataLayer.push({'event': 'dislike', 'businessId': businessId});
                }
                APICall.AddBusinessLike(data, accessToken, (response) => {
                    console.log('');
                })
            }
        }
        else {
            handleCloseButtonClick(createPassword);
        }
    }
      
    const handleShare = () => {
        if (Object.keys(businessData).length === 0) {
            return
        }
        window.dataLayer.push({'event': 'share_click', 'businessId': businessId, 'clickedFrom': 'business_sheet'});
        if (!props.business) return

        if (navigator.share) {
            navigator.share({
                // title: 'RS11',
                text: `Click here to view RS11's FREE estimated value of ${props.business.fields.business_name} business in ${props.business.fields.location_address_city} and estimated value of millions of more businesses in the US.`,
                url: `${window.location.origin}/map?id=${businessData.fields.srno}&type=${(businessData.fields.business_type == 'Airbnb' ? 1 : 2)}`,
            })

            .then(() => {
                console.log('Successful share');
            })
            .catch(error => console.log('Error sharing:', error));        
        }
        else {
            setOpenShare(true);
        }
    }

    useEffect(() => {
        let accessToken = Cookies.get('access_token') ?? null;
        if (accessToken != null) {
            setShowValuationData(true);
        }
        else {
            setShowValuationData(false);
        }

        if (props.business) {
            (props.business.fields.valuation) && setValuationValue(props.business.fields.valuation);

            let params = {'business_id': props.business.id, 'type': props.business.fields.category}
            if (accessToken == null)
                APICall.GetBusinessData(params, (response) => {
                    if (response.status == 200 && response.data.status == 'success') {
                        setBusinessData(response.data.data);
                    }
                });
            else {
                // setShowLoader(true);
                APICall.GetBusinessValuation({'business_id': props.business.id, 'type': props.business.fields.category}, accessToken, (response) => {
                    if (response == undefined) {
                        return
                    }
                    if (response.status == 200 && response.data.status == 'success') {
                        // setShowLoader(false);
                        setBusinessData(response.data.data);
                        setUserLiked(response.data.data.additional_data.liked);
                        (response.data.data.additional_data.business_interests != null) && setActive(response.data.data.additional_data.business_interests);
                    }
                });
            }
        }

    }, [props.business]);

    // useEffect(() => {
    //     if (showLoader && toolTipElement.current) {
    //         toolTipElement.current.style.opacity = '0.5';
    //     }
    //     else if (!showLoader && toolTipElement.current) {
    //         toolTipElement.current.style.opacity = '1';
    //     }
    // }, [showLoader]);

    useEffect(() => {
        // Add event listener to document
        document.addEventListener('click', handleClickOutside, true);
    
        // Clean up event listener on unmount
        return () => {
          document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const handleClickOutside = (event) => {
        if (toolTipElement.current && toolTipElement.current.contains(event.target)) {
            setOpenShare(false);
        }
    };

    const handleOwnBusiness = () => {
        window.dataLayer.push({'event': 'claim_business_start', 'businessId': businessId});
        handleCloseButtonClick('own');
    }

    const handleContactBusiness = () => {
        window.dataLayer.push({'event': 'contact_business_start', 'businessId': businessId});
        if (accessToken == null) {
            handleCloseButtonClick(createPassword)
        }
        else {
            handleCloseButtonClick('contact');
        }
    }

    const handleCloseShare = (actions) => {
        if (actions == 'copy_link') {
            setShowCopiedMessage(true);
            setTimeout(() => {
                setShowCopiedMessage(false);
            }, 2000);
        }
        setOpenShare(false)
    }

    const handleCloseBusinessInterests = (action, selectedOptions) => {
        (action != 'close') && setActive(selectedOptions);
        if (action == 'success') {
            if (interestElement.current) {
                interestElement.current.style.display = 'none';
            }
            setShowThanksMessage(true);
        }
        setOpenBusinessInterests(false);
    }

    const handleSignUp = () => {
        setGoText('Submitting...');
        let suggester = null;
        let storedSuggester = window.localStorage.getItem('suggester');
        (storedSuggester == 'zipcode') && (suggester = 'zip_code');
        (storedSuggester == 'city') && (suggester = 'location_address_city');
        var data = {
            email: emailAddress,
            suggester: suggester,
            business_id: businessId,
            business_type: props.business.fields.category,
            suggested_value: suggestedValue,
        }

        APICall.CreateAccount(data, (response) => {
            setGoText('Go');
            // Google Event For signup initiated
            window.dataLayer.push({'event': 'sign_up', 'businessId': businessId, 'method': 'email'});
            if (response.status == 200 && response.data.status == 'success'){
                Cookies.set('signup_id', emailAddress);
                handleCloseButtonClick('inbox');
            }
            else {
                if (response.data.message == 'Email already exists. Please signin!') {
                    setShowLoginLink(true);
                }
                else {
                    setSignUpError(response.data.message);
                    setShowSignUpError(true);
                }
            }
        });

    }

    const imgStyle = {
        filter: 'invert(13%) sepia(94%) saturate(7466%) hue-rotate(0deg) brightness(94%) contrast(115%)' // Replace this with the desired filter or styling
      };
    
  
    return(
        <>
        {
            (openBusinessInterests) && (
                <BusinessInterestSheet 
                    closeBusinessInterests={handleCloseBusinessInterests}
                    selectedBusinessData={(businessData)}
                    active={active}
                /> 
            ) 
        }
        {
            
            (props.business) && (
            <BottomSheet open={props.isBottomSheetOpen} data-body-scroll-lock-ignore="true" onDismiss={() => handleCloseButtonClick(closeSheet)}
                header={
                    <div className="transparent-header">
                        <img className='cancel-icon' height='25px' src={cancelIcon} onClick={() => handleCloseButtonClick(closeSheet)} />
                    </div>
                }
            >
                {
                    (openShare) && (
                        <Share url={`${window.location.origin}/map?id=${businessData.fields.srno}&type=${(businessData.fields.business_type == 'Airbnb' ? 1 : 2)}`} businessData={businessData} closeShare={handleCloseShare} />
                    )
                }
                <div className='mobile-claim-container' ref={toolTipElement}>   
                    <div className='logo-name-container'>
                        <div className='business-category-container'>
                            <SVGImage category={props.business.fields.category} />
                            <p>{selectCategoryName(props.business.fields.category)}</p>
                        </div>

                        <div className='name-address-container'>
                            <div>
                                <p className='business-name-text' title={props.business.fields.business_name}>{trimCharacters(props.business.fields.business_name)}</p>
                                {
                                    (props.business.fields.full_address) ? (
                                        <p className='business-address'>{props.business.fields.full_address}</p>
                                    ) : (
                                    (props.business.fields.category != 'Airbnb') ? (
                                        <p className='business-address'>{props.business.fields.location_address},&nbsp; 
                                        {props.business.fields.location_address_city},&nbsp;{props.business.fields.location_address_state},&nbsp;
                                        {props.business.fields.zip_code}</p>) : (
                                        <p className='business-address'>{props.business.fields.location_address}</p>
                                    ))
                                }
                            </div>
                            <div>
                                {
                                    (Cookies.get('access_token') ?? null != null) ? (
                                    <button className={!userLiked ? "like-button" : "like-button selected"} onClick={handleLikeBusiness}></button>) : (
                                    <button className={"like-button disable"}></button>
                                    )
                                }
                                <img className='share-image' src={shareGrey} onClick={handleShare} />
                            </div>
                        </div>
                    </div>
                    <div className='estimation-content'> 
                      
                        <div>
                            <div className='estimation-container'>
                                <p className='estimate-text'>RS11 ESTIMATED VALUE</p>
                                {
                                    (showValuationData) ? (
                                    <div>
                                        {
                                            (props.business) && (
                                            (valuationValue != null && parseFloat(valuationValue) != 0) ? (
                                            <p className={'estimate-value'}>${(parseFloat(valuationValue)).toLocaleString()}</p>) : (
                                            <p className='estimate-value'>Coming Soon</p>
                                            ))
                                        }
                                    </div>
                                            
                                        ) : (
                                        <p className={'estimate-value'}>$<span className='value-blur'>000<span className='estimate-value'>,</span>000</span></p>
                                    )
                                }
                            </div>
                            {
                                (!showValuationData) && (
                                    <div className='signup-data'>  
                                        <p className='enter-email-text'>In order to see the RS11 estimated value of this business and millions more please enter your email address.</p>
                                        <input 
                                            className="input-value" 
                                            type="email"
                                            id='signup-email'
                                            placeholder='Email Address' 
                                            value={emailAddress}
                                            onChange={(e) => setEmailAddress(e.target.value)}
                                            onKeyPress={(e) => ((e.key == 'Enter') && handleSignUp())}
                                        />
                                        {
                                            (emailAddress.trim().length != 0) ? (
                                                <Submit actionText={goText} callFunction={handleSignUp} disable={goText != 'Go' && true} />
                                                ) : (
                                                <Submit actionText={'Go'} disable={'button'} />

                                            )
                                        }
                                        {
                                            (showSignUpError) && (
                                            <p className='signup-error'>{signUpError}</p>)
                                        }  
                                        {
                                            (showLoginLink) && (
                                            <p className='signup-error'>Email already exists. Please sign in. <span onClick={() => handleShowLogin()}>Sign in</span></p>)
                                        }  
                                        <p className='user-signins'>
                                            <span className='user-text'>Already member? </span>
                                            <span className='process-text' onClick={() => handleShowLogin()}>Sign In</span>
                                        </p>                           
                                    </div>
                                )
                            }
                            {
                                (showValuationData) && (
                                <div ref={interestElement}>
                                    <p className='interest-text'>Why are you interested in this business value?</p>
                                    <div className='select-interest-options'>
                                        <div onClick={() => handleShowInterestDropdown()}>
                                            <p className='selected-values'>
                                                {active.length == 0 ? 'Select option' : active.map((item, i) => (
                                                (i + 1) != active.length ? Mappings[item] + ', ' : Mappings[item]
                                                ))}
                                            </p>
                                        </div>
                                        <i onClick={() => handleShowInterestDropdown()}></i>
                                    </div>
                                </div>)
                            }
                            {
                                (showThanksMessage) && (
                                <p className='interest-message'>Thank you for letting us know!</p>)
                            }
                        </div>
                           
                    </div>
                    {
                        (showCopiedMessage) && (
                        <div className='copied-text'>Copied to clipboard!</div>)
                    }
                    {
                        (showValuationData) && (
                        <div className='button-container'>
                            <Submit actionText={'Contact business'} callFunction={handleContactBusiness} />
                            <button className='own-manage' onClick={() => handleOwnBusiness()}>
                                Own or manage this business?
                            </button>
                            {/* <Submit actionText={'I own/manage this business'} callFunction={handleOwnBusiness} /> */}
                        </div>)
                    }

                </div>
            </BottomSheet>)
        }
        </> 
    )
}

export default ClaimBottomSheet;
